import { useMutation } from "react-query";
import api from "../../client";
import {
  PlacementEnvironmentTemplateListItem,
  UpdatePlacementEnvironmentTemplatePayload,
} from "../../types/placement-environment-template";

const patchData = async (
  id: string | undefined,
  payload: UpdatePlacementEnvironmentTemplatePayload,
): Promise<PlacementEnvironmentTemplateListItem> => {
  const { data } = await api.patch(
    `/placement-environment-templates/${id}`,
    payload,
  );

  return data;
};

export const useUpdatePlacementEnvironmentTemplate = (
  id: string | undefined,
) => {
  return useMutation((payload: UpdatePlacementEnvironmentTemplatePayload) => {
    return patchData(id, payload);
  });
};
